export const MAX_FEATURE_VISIT_COUNT = 3;
